import React from "react";
import { connect } from "react-redux";

import { getClosestPrizeByScore } from "../../prize/prize.selectors";
import { getCurrentUser } from "../user.selectors";

import { ContentBlock } from "../../pages/components";
import colorThemes from "../../../ui/colorThemes";
import ScoreVisualizer from "../../../ui/score/ScoreVisualizer";

const ScoreVisualizerBlock = props => {
  const { currentUser, closestPrize } = props;

  if (!currentUser || !closestPrize) return null;
  const { score } = currentUser;
  const { price } = closestPrize;

  const percentage = Math.max(0, Math.min(score / price, 1)) * 100;

  return (
    <ContentBlock half theme={colorThemes.TRANSPARENT}>
      <ScoreVisualizer score={Math.floor(score)} percent={percentage} />
    </ContentBlock>
  );
};

const mapStateToProps = state => {
  const currentUser = getCurrentUser(state);
  const closestPrize = getClosestPrizeByScore(state);

  return {
    currentUser,
    closestPrize
  };
};

const ConnectedScoreVisualizerBlock = connect(mapStateToProps, null)(ScoreVisualizerBlock);

export default ConnectedScoreVisualizerBlock;



// WEBPACK FOOTER //
// ./src/modules/user/components/ScoreVisualizerBlock.js